import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const GridContainer = styled(Grid)``
export const GridIconCard = styled(Grid)``
